














import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class CardIcon extends Vue {
	@Prop({required: true}) readonly iconName: string;
	@Prop({required: true}) readonly backgroundPosition: string;
}
